module.exports = __webpack_public_path__ + "static/media/deeplearning.ai.3c100604.png";